import { collection, query, where, getDocs, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../config';
import { handleFirebaseError } from '../../../error-handling';

export async function removeInstructorFromOrganization(
  organizationId: string,
  instructorId: string
): Promise<boolean> {
  try {
    const memberId = `${organizationId}_${instructorId}_instructor`;
    const memberRef = doc(collection(db, 'organizationMembers'), memberId);
    const existing = await getDoc(memberRef);
    if (existing.exists()) {
      await deleteDoc(memberRef);
      return true;
    }

    // Fallback for legacy duplicates
    const memberQuery = query(
      collection(db, 'organizationMembers'),
      where('organizationId', '==', organizationId),
      where('userId', '==', instructorId),
      where('role', '==', 'instructor')
    );
    const memberSnapshot = await getDocs(memberQuery);
    if (!memberSnapshot.empty) {
      await Promise.all(memberSnapshot.docs.map(d => deleteDoc(d.ref)));
      return true;
    }
    
    return false;
  } catch (error) {
    handleFirebaseError(error, 'Error removing instructor from organization');
    return false;
  }
}